export const USER_ROLE_SUPERADMIN = 'SuperAdmin'
export const USER_ROLE_COMPANYADMIN = 'CompanyAdmin'
export const USER_ROLE_BUILDINGADMIN = 'BuildingAdmin'
export const USER_ROLE_OFFICEADMIN = 'OfficeAdministrator'
export const USER_ROLE_USER = 'User'